export const GLOBAL_ANIMATION = "animation: all 0.25s ease";
export const GLOBAL_TRANSITION = "transition: all 0.25s ease";
